module.exports = __webpack_public_path__ + "img/miryoku3.8f6fab81.jpg";